// extracted by mini-css-extract-plugin
module.exports = {"DebtSituation":"index-module_DebtSituation_229QH"};